"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLES = void 0;
var DEFAULT_STYLES = {
  ICON: {
    FONTSIZE: 'titleNormal'
  },
  RATING: {
    COLOR: 'primary',
    TYPE: 'small'
  },
  LABEL: {
    WIDTH: '169px',
    TYPE: 'sub'
  },
  IMAGE: {
    WIDTH: '32.41px',
    HEIGHT: '38.89px',
    PLACEHOLDER_BG: 'default',
    RADIUS: '0px'
  },
  TEXT_CONTAINER: {
    MARGIN_LEFT: '20px',
    COMPACT: '0px'
  }
};
exports.DEFAULT_STYLES = DEFAULT_STYLES;